import React, { useState, useEffect, useMemo } from 'react';
import './pagination.css';   // Mantén tus estilos separados

export default function Pagination({ currentPage, totalPages, onPageChange }) {
    // Detectar móvil internamente
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Generar lista de páginas según dispositivo
    const pages = useMemo(() => {
        if (!isMobile) {
            // Desktop: todas las páginas
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }
        // Móvil: solo primero, actual y último
        const setPages = new Set([1, currentPage, totalPages]);
        return Array.from(setPages).sort((a, b) => a - b);
    }, [isMobile, currentPage, totalPages]);

    const go = (page) => {
        if (page < 1 || page > totalPages || page === currentPage) return;
        onPageChange(page);
    };

    return (
        <nav aria-label="Page navigation">
            <ul className="gallery-pagination">
                <li>
                    <button
                        className="pagination-btn"
                        onClick={() => go(currentPage - 1)}
                        disabled={currentPage === 1}
                        aria-label="Previous page"
                    >
                        ‹
                    </button>
                </li>

                {pages.map((num, idx) => (
                    <li key={`${num}-${idx}`}>
                        <button
                            className={`pagination-btn ${currentPage === num ? 'active' : ''}`}
                            onClick={() => go(num)}
                            aria-current={currentPage === num ? 'page' : undefined}
                        >
                            {num}
                        </button>
                    </li>
                ))}

                <li>
                    <button
                        className="pagination-btn"
                        onClick={() => go(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        aria-label="Next page"
                    >
                        ›
                    </button>
                </li>
            </ul>
        </nav>
    );
}
